import { styled, createStyles, makeStyles, withStyles, Dialog, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const Row = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    dialogContent: {
      padding: '64px',

      '&:first-child': {
        paddingTop: '64px',
      },

      [theme.breakpoints.down('sm')]: {
        padding: '40px 12px',

        '&:first-child': {
          paddingTop: '40px',
        },
      },
    },
    paper: {
      borderImageSource: 'none',
      borderColor: COLORS.PRIMARY,
    },
    hiddenMobile: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    mobileDiv: {
      display: 'none',
      gridColumn: '1 /span 2',

      [theme.breakpoints.down('sm')]: {
        display: 'flex',
      },
    },
    contentHeadCont: {
      display: 'flex',
      position: 'relative',
      gap: 20,
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'grid',
        gridTemplateColumns: '125px 1fr',
      },
    },
    closeButton: {
      position: 'absolute',
      top: 0,
      right: 0,
    },
    helloText: {
      fontSize: 20,
      color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
      marginBottom: 16,
      fontWeight: 600,
    },
    missingInfos: {
      margin: '30px auto',
      width: '100%',
      padding: 16,
      backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_DRAWER : '#dbdbdb',
      borderRadius: 6,

      '&.loader': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
      },
    },
    missingInfoInstruction: {
      fontWeight: 500,
      fontSize: 16,
      marginBottom: 16,
    },
    infoDetails: {
      fontSize: 18,

      '&.missing': {
        color: COLORS.ERROR,
      },
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(4),
    },
    buttonContainer: {
      marginTop: theme.spacing(4),
      display: 'flex',
      justifyContent: 'space-between',
    },
    updateBtn: {
      padding: '10px 40px',
      height: 50,
      alignItems: 'center',
    },
    select: {
      backgroundColor:
        theme.palette.type === 'dark'
          ? `${COLORS.DARK_FIELDS_ON_CARD_MENU} !important`
          : COLORS.LIGHT_MENUITEM_BACKGROUND,

      '& > fieldset': {
        border: 'none',
      },
    },
    section: {
      paddingBottom: 15,
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: theme.palette.type === 'dark' ? '#384351' : '#d1d1d1',
      marginBottom: 15,

      '&.no-border': {
        borderBottom: 'none',
      },
    },
    sectionTitle: {
      fontSize: 16,
      fontWeight: 'bold',
      marginBottom: 11,
    },
    infoContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 15,

      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        columnGap: 0,
      },
    },
    redirectBtn: {
      padding: '10px 24px',
      minWidth: 220,
      height: 40,
      alignItems: 'center',
      border: `solid 1px ${COLORS.PRIMARY}`,
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
      marginLeft: 'auto',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        order: 3,
      },
    },
    info: {
      display: 'flex',
      width: '100%',
      padding: '12px 16px',
      borderRadius: '4px',
      borderLeft: 'solid 3px #4e8ded',
      backgroundColor: theme.palette.type === 'dark' ? '#1e3456' : '#b7d1f8',
      alignItems: 'flex-start',
      fontSize: 12,
      columnGap: 8,

      '&.warning': {
        borderLeft: 'solid 3px #e6696b',
        backgroundColor: theme.palette.type === 'dark' ? '#652a2b' : '#ead1d2',
        maxWidth: '344px',

        [theme.breakpoints.down('sm')]: {
          maxWidth: 'none',
        },
      },

      '&.full-col': {
        gridColumn: '1 /span 2',
      },
    },
    infoIcon: {
      width: 16,
      height: 16,
      flexShrink: 0,
      '& path': {
        stroke: '#4e8ded',
      },

      '&.warning': {
        transform: 'rotate(-0.5turn)',
        '& path': {
          stroke: '#e6696b',
        },
      },
    },
    doNotShowAgain: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
);

export const StyledDialog = withStyles((theme: Theme) => ({
  paper: {
    backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.LIGHT_BACKGROUND,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderImageSlice: '1',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '8px !important',
  },
}))(Dialog);
